import axios from 'axios';
import Cookies from 'js-cookie';

const instance = axios.create({
    baseURL: window.location.protocol + '//' + window.location.host + '/api'
});

instance.interceptors.response.use(
    response => response,
    error => {
        const status = error.response?.status;
        const isLoginRoute = error.config?.url?.includes('/login');
        const tinhaSessao = !!Cookies.get('anth-token');

        if (status === 401 && !isLoginRoute && tinhaSessao) {
            Cookies.remove('anth-token');
            Cookies.remove('username');
            window.dispatchEvent(new CustomEvent('session-expired'));
            window.location.href = '/acesso?sessao=expirada';
        } else if (status === 403) {
            window.dispatchEvent(new CustomEvent('access-forbidden'));
        }
        return Promise.reject(error);
    }
);

export default instance;